import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

const ImageLoad = ({ imgsrc, rounded, imgalt, ...props }) => {
    return (
      <StaticQuery
        query={graphql`
          query {
            allImageSharp {
              edges {
                node {
                  fluid(maxWidth: 2400) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        `}
        render={data => {
          return (
            <Img style={ rounded ? { borderRadius: '50%' } : '' } alt={imgalt} fluid={data.allImageSharp.edges.find((element) => {
              return (element.node.fluid.src.split('/').pop() === imgsrc);
            }).node.fluid} />
          )
        }}
      />
    )
}

export default ImageLoad;
